import { useEffect, useState } from "react";
import api from "../api/api";

function AdminOverview() {
  const [revenue, setRevenue] = useState(0);
  const [vendors, setVendors] = useState([]);
  const [papers,  setPapers]  = useState([]);

  useEffect(() => {
    api.get("/admin/totalRevenue").then(res => setRevenue(res.data)).catch(() => {});
    api.get("/admin/vendors").then(res => setVendors(Array.isArray(res.data) ? res.data : [])).catch(() => {});
    api.get("/admin/newspapers").then(res => setPapers(Array.isArray(res.data) ? res.data : [])).catch(() => {});
  }, []);

  const activeVendors = vendors.filter(v => v.active).length;

  return (
    <div className="page">
      {/* Stats Row */}
      <div className="stats-grid">
        <div className="stat-card gold">
          <span className="stat-emoji">📰</span>
          <div className="stat-value">{papers.length}</div>
          <div className="stat-label">Active Newspapers</div>
        </div>
        <div className="stat-card green">
          <span className="stat-emoji">🚴</span>
          <div className="stat-value">{activeVendors}</div>
          <div className="stat-label">Active Vendors</div>
        </div>
        <div className="stat-card blue">
          <span className="stat-emoji">👥</span>
          <div className="stat-value">{vendors.length}</div>
          <div className="stat-label">Total Vendors</div>
        </div>
        <div className="stat-card red">
          <span className="stat-emoji">₹</span>
          <div className="stat-value">₹{revenue}</div>
          <div className="stat-label">Total Revenue</div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 22 }}>
        {/* Newspapers list */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">📰 Newspapers</div>
          </div>
          <div className="card-body no-pad">
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Language</th>
                    <th>Daily</th>
                    <th>Monthly</th>
                  </tr>
                </thead>
                <tbody>
                  {papers.length === 0 && (
                    <tr><td colSpan={4} style={{ textAlign: "center", color: "var(--muted)" }}>No newspapers yet</td></tr>
                  )}
                  {papers.map(p => (
                    <tr key={p.newspaperId}>
                      <td><strong>{p.name}</strong></td>
                      <td><span className="badge badge-muted">{p.language || "—"}</span></td>
                      <td className="text-gold fw-700">₹{p.dailyPrice}</td>
                      <td className="text-gold fw-700">₹{p.monthlyPrice}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Vendors list */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">🚴 Vendors</div>
          </div>
          <div className="card-body no-pad">
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {vendors.length === 0 && (
                    <tr><td colSpan={3} style={{ textAlign: "center", color: "var(--muted)" }}>No vendors yet</td></tr>
                  )}
                  {vendors.map(v => (
                    <tr key={v.vendorId}>
                      <td>
                        <div className="flex-center gap-8">
                          <div className="user-avatar" style={{ width: 28, height: 28, fontSize: 11 }}>
                            {v.name[0]}
                          </div>
                          <strong>{v.name}</strong>
                        </div>
                      </td>
                      <td className="text-muted fs-13">{v.phone}</td>
                      <td>
                        <span className={`badge ${v.active ? "badge-success" : "badge-danger"}`}>
                          {v.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminOverview;
